import { collection, doc, setDoc, query, where, getDocs } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../../firebase"; // Configuración de Firebase

const papeleriaCollectionName = "papeleria";

// Obtener documentos filtrados por cliente
export const getPapeleria = async (codigoCliente) => {
  try {
    const papeleriaCollection = collection(db, "papeleria");
    const papeleriaQuery = query(papeleriaCollection, where("CodigoCliente", "==", codigoCliente));
    const snapshot = await getDocs(papeleriaQuery);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error al obtener papelería:", error);
    throw error;
  }
};

// src/services/storageService.js
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(
    `https://firebasestorage.googleapis.com/v0/b/armeniaescobar.appspot.com/o?name=${file.name}`,
    {
      method: 'POST',
      body: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  const data = await response.json();
  return data;
};
export const subirDocumento = async (formData) => {
  const {
    CodigoCliente,
    CodigoTipoDoc,
    FechaVencimiento,
    FechaCarga,
    DocumentoAdjunto,
    NombreDocumento, // Incluye este campo
  } = formData;

  if (!DocumentoAdjunto || typeof DocumentoAdjunto !== "object" || !DocumentoAdjunto.name) {
    throw new Error("El archivo no es válido o no se ha seleccionado.");
  }

  try {
    const fileRef = ref(storage, `papeleria/${CodigoCliente}/${DocumentoAdjunto.name}`);
    await uploadBytes(fileRef, DocumentoAdjunto);
    const fileURL = await getDownloadURL(fileRef);

    const papeleriaCollection = collection(db, papeleriaCollectionName);
    const q = query(
      papeleriaCollection,
      where("CodigoCliente", "==", CodigoCliente),
      where("CodigoTipoDoc", "==", CodigoTipoDoc)
    );
    const querySnapshot = await getDocs(q);

    const documentData = {
      CodigoCliente,
      CodigoTipoDoc,
      FechaVencimiento,
      FechaCarga,
      DocumentoURL: fileURL,
      NombreDocumento, // Usa el nombre enviado desde el estado
    };

    if (!querySnapshot.empty) {
      const existingDocId = querySnapshot.docs[0].id;
      const docRef = doc(db, papeleriaCollectionName, existingDocId);
      await setDoc(docRef, documentData);
      console.log("Documento actualizado correctamente:", existingDocId);
    } else {
      const newDocRef = doc(db, papeleriaCollectionName);
      await setDoc(newDocRef, documentData);
      console.log("Documento creado correctamente:", newDocRef.id);
    }

    return documentData;
  } catch (error) {
    console.error("Error al subir el documento:", error);
    throw error;
  }
};
